import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TrackClickDirective } from './directive/track-button-click.directive';


@NgModule({
  declarations: [TrackClickDirective],
  imports: [CommonModule],
  exports: [TrackClickDirective] // Export it to use in other modules
})
export class MixpanelModule {}
